import { createContext, useContext } from "react";
import type { Session } from "../services/types";

// Lazy way to make the session available to nested routes without
// prop-drilling. AppShell is the single source of truth, so every protected
// route can read this with `useSession()`.

const SessionContext = createContext<Session | null>(null);

export const SessionProvider = SessionContext.Provider;

export function useSession(): Session | null {
  return useContext(SessionContext);
}